var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "lpu-rating-category-card bg-gray-0 rounded-20 pa-4 overflow-hidden",
      attrs: { "data-qa": "lpu_rating_category_card" },
    },
    [
      _c("div", { staticClass: "d-flex flex-column ga-2 relative" }, [
        _c(
          "div",
          {
            staticClass: "text--text font-weight-medium",
            class: _vm.hasScore
              ? "lpu-rating-category-card__score--value"
              : "text-body-1 text-info--text",
          },
          [_vm._v("\n      " + _vm._s(_setup.scoreText) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-1 text-secondary--text" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c(_setup.MaskIcon, {
        staticClass:
          "lpu-rating-category-card__icon text-lpu-branding-color-primary",
        attrs: { src: _vm.iconSrc, size: 110 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }